<template>
  <div>
    <img :width="width" src="/wp-content/themes/genesis-go2roues/svg/Spinner-1s-200px.svg" alt="spinner">
  </div>
</template>

<script>
  export default {
    props: {
      width: {
        type: [Number, String],
        required: false,
        default: 100,
      }
    },
    name: "SvgSpinner",
  }
</script>

<style scoped>
  div {
    display: flex;
    justify-content: center;
  }
</style>
